import { FeatureCollection } from 'geojson';
import { get } from './common';

export const getBounds = async () => {
  return get<FeatureCollection>(`/v1/config/map/bounds.json`);
};

export default getBounds;
